<template>
  <div class="flex-container">
    <div class="flex-item" @click="openSliderLeft">
      <Badge :value="valuesCount" class="item filter-badge">
        <Button>
          <svgicon name="filtericon" class="icon" width="13" height="13" />
          Filter
        </Button>
      </Badge>
    </div>
    <div class="flex-item">
      <span v-for="(value,index) in validValues" :key="index" :id="index">
        <Tag
          v-if="value && value.type === 'List' && value.selected &&
           (value.selected.label || value.selected.name || value.selected.tlabel)"
          class="tag-default"
          size="small"
          effect="plain">
          <span>{{value.selected.tlabel ? $t(value.selected.tlabel) : $t(value.selected.label || value.selected.name) }}</span>
        </Tag>
        <Tag
          v-else-if="value && value.type === 'MultiSelectList' && value.selected.length > 0"
          class="tag-default"
          size="small"
          effect="plain">
            <span v-if="value.selected.length === 1">{{value.selected[0].name}}</span>
            <span v-else>{{value.selected.length}} {{$t(value.category)}}s selected</span>
         </Tag>
        <Tag
          v-else-if="value && value.type === 'MultiSelectGroup' && value.selected.length > 0"
          class="tag-default"
          size="small"
          effect="plain">
            <span v-if="value.selected.length === 1">{{value.selected[0].name}}</span>
            <span v-else>{{value.selected.length}} {{$t(value.category)}}s selected</span>
          </Tag>
        <Tag
          v-else-if="value && value.type === 'Date' && getFormattedDate(value.startDate, value.endDate)"
          class="tag-default"
          size="small"
          effect="plain">
            <span>{{getFormattedDate(value.startDate, value.endDate)}}</span>
          </Tag>
          <Tag
            v-else-if="value && value.type === 'DatePicker' &&
              getFormattedDate(value.startDate, value.endDate)"
            class="tag-default"
            size="small"
            effect="plain">
            <span>{{getFormattedDate(value.startDate, value.endDate)}}</span>
          </Tag>
          <Tag v-else-if="value && value.type === 'SingleDate' && getFormattedDate(value.selected)"
            class="tag-default"
            size="small"
            effect="plain">
              <span> {{getFormattedDate(value.selected)}} </span>
          </Tag>
        <Tag
          v-else-if="value && value.type === 'GroupList' && value.selected"
          class="tag-default" size="small" effect="plain">
          <span>{{value.selected.tlabel ? $t(value.selected.tlabel) : value.selected.display_label}}</span>
        </Tag>
      </span>
    </div>
  </div>
</template>

<script>
import { formatDisplayDate, formatDisplaySingleDate } from '@/lib/Date';
import { legTypeMapping } from 'pando-constants';
export default {
  props: ['values'],
  computed: {
    valuesCount() {
      return (this.validValues && this.validValues.length) || 0;
    },
    validValues() {
      return this.values && this.values.reduce((acc,valueConstant) => {
        let value = Object.assign({}, valueConstant);
        if((value.type === 'List' && value.selected && value.selected.id !== -1) ||
          (value.type === 'MultiSelectList' && value.selected.length > 0) ||
          (value.type === 'MultiSelectGroup' && value.selected.length > 0) ||
          (value.type === 'SingleDate' && value.selected) ||
          (value.type === 'Date' && value.startDate && value.endDate) ||
          (value.type === 'DatePicker' && value.startDate && value.endDate) ||
          (value.type === 'GroupList' && value.selected && value.selected.group_type !== -1)) {
            if(value.type === 'MultiSelectList') {
              const selecteditem = value.selected.filter(item => item.id !== 0
                && item.name !== 'Select All')
              value.selected = [...selecteditem]
              if (value.category === 'Status') {
                value.category = `${value.category}e`;
              }
            } else if(value.type === 'GroupList'){
                value.selected.display_label = value.selected.name || value.selected.group_type;
            }
            else if(value.selected && value.selected.tag_display_label) {
              value.selected.display_label = value.selected.tag_display_label;
            }
            acc.push(value);
          }
          return acc;
      }, []);
    },
  },
  methods: {
    openSliderLeft() {
      this.$emit('openSliderLeft');
    },
    getFormattedDate(startDate, endDate = null) {
      if(endDate) {
        return formatDisplayDate(startDate,endDate);
      }
      return formatDisplaySingleDate(startDate);
    },
  },
};
</script>
